import React, { useEffect, useState } from 'react'

import Auth from '../components/Auth/Auth'
import Email from '../components/Auth/Email'
import UserInfo from '../components/Auth/UserInfo/UserInfo'
import VerificationCode from '../components/Auth/VerificationCode'
import Logo from '../components/Layout/Logo'
import styles from '../styles/Signup.module.css'


interface SignupDetails {
    email: string;
    token: string;
    firstName: string;
    lastName?: string;
    password: string;
    confirmPassword: string;
    activeComponent: string;
    profilePicture?: File | null, 
}

interface SignupContext {
    signupDetails: SignupDetails;
    user: SignupDetails;
    setUser: (user: SignupDetails) => void
}

export const SignupCtx = React.createContext<SignupContext | null>(null)

const SignUp = () => {
    
    const signupDetails: SignupDetails = {
        email: '',
        token: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        activeComponent: '',
        profilePicture: null, 
    }
    
    const [user, setUser] = useState<SignupDetails>(signupDetails)

    return (
        <div className={`container ${styles.alignVerticalCenter}`}>
            <div>
                <header className='d-flex justify-content-center align-items-center'>
                    <Logo width='auto' height='44px' alt="Logo" />
                </header>
                <main className='main-wrapper'>
                    <SignupCtx.Provider value={{signupDetails, user, setUser}}>
                        {
                            user.activeComponent === '' && <Auth />
                        }
                        {
                            user.activeComponent === 'email' && <Email />
                        }
                        {
                            user.activeComponent === 'code' && <VerificationCode />
                        }
                        {
                            user.activeComponent === 'user' && <UserInfo />
                        }
                    </SignupCtx.Provider>
                </main>
            </div>
        </div>
    )
}

export default SignUp
